import React, { useEffect, useRef } from "react";
import ModalActions from "components/ModalActions";
import { Formik } from "formik";
import Pill from "components/Pill";
import TextareaController from "components/TextareaController";
import { focusInputRefEnd, submitOnReturn } from "utils/form";
import classnames from "classnames";
import { FEATURE_FIELDS } from "utils/constants/feature";

const FeatureForm = ({
  feature,
  featureGroup,
  setShowModal,
  updateFeature
}) => {
  const initialValues = FEATURE_FIELDS.reduce((memo, { key }) => {
    memo[key] = feature[key] || "";
    return memo;
  }, {});

  const inputRef = useRef(null);
  useEffect(() => {
    focusInputRefEnd(inputRef);
  }, []);

  return (
    <Formik initialValues={initialValues}>
      {({ values }) => {
        const submitForm = () => updateFeature(values);
        return (
          <div className="w-100 h-100 h-auto-ns center ph3 pb3">
            <div className="w-100 bb hairline-1 pb3">
              <div className="f3">{feature.title}</div>
              <div className="flex flex-row pt3 items-center">
                <div className="f6 fw5">Group</div>
                <div className="pl2">
                  <Pill
                    customClasses={{
                      container: "dib"
                    }}
                    theme="slim"
                    copy={featureGroup.title}
                  />
                </div>
              </div>
            </div>
            {FEATURE_FIELDS.map(({ key, label }, fieldIx) => {
              const isLast = FEATURE_FIELDS.length - 1 === fieldIx;
              return (
                <div
                  key={`${key}-${fieldIx}`}
                  className={classnames("pv3", {
                    "bb hairline-1": !isLast
                  })}
                >
                  <TextareaController
                    name={key}
                    label={label}
                    minRows={1}
                    innerRef={inputRef}
                    debounce={250}
                    onKeyPress={submitOnReturn({
                      submitForm
                    })}
                  />
                </div>
              );
            })}
            <ModalActions
              actions={[
                {
                  cta: "Cancel",
                  onClick: () => {
                    setShowModal(false);
                  }
                },
                {
                  cta: "Update",
                  onClick: submitForm
                }
              ]}
            />
          </div>
        );
      }}
    </Formik>
  );
};

export default FeatureForm;
